<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-layout row wrap justify-center align-center>
            <v-dialog v-model="dialogComponent" max-width="800" persistent>
               <v-card>
                  <v-toolbar color="white" class="elevation-0" card>
                     <v-toolbar-title class="headline font-weight-light">Empresas Cadastradas</v-toolbar-title>
                     <v-spacer></v-spacer>
                     <v-toolbar-items>
                        <v-btn @click="closeDialog" color="error" round icon flat>
                           <v-icon color="error" large>clear</v-icon>
                        </v-btn>
                     </v-toolbar-items>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-card-text>
                     <v-container fluid>
                        <v-layout row wrap>
                           <v-flex xs12 v-for="(comp,i) in companies" :key="i">
                              <v-card class="my-1 card-company" @click="showList(comp) ">
                                 <v-card-title v-text="companyText(comp)"></v-card-title>
                              </v-card>
                           </v-flex>
                           <!-- Dialog de acessos -->
                           <v-dialog
                              v-model="list"
                              max-width="800"
                              persistent
                              hide-overlay
                              transition="dialog-bottom-transition"
                           >
                              <v-card>
                                 <v-toolbar color="white" class="elevation-0" card>
                                    <v-toolbar-title
                                       class="headline font-weight-light"
                                    >Acessos Autorizados</v-toolbar-title>

                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                       <v-btn @click="list = false" color="error" round icon flat>
                                          <v-icon color="error" large>clear</v-icon>
                                       </v-btn>
                                    </v-toolbar-items>
                                 </v-toolbar>
                                 <v-divider></v-divider>
                                 <v-card-text>
                                    <v-container grid-list-md>
                                       <v-layout wrap>
                                          <v-flex
                                             class="absolute"
                                             xs12
                                             md6
                                             v-for="(item,i) in entitiesList"
                                             :key="i"
                                          >
                                             <v-combobox
                                                v-model="selected[i]"
                                                :readonly="state"
                                                :items="actions"
                                                item-text="title"
                                                item-value="value"
                                                :prepend-icon="item.icon"
                                                multiple
                                                chips
                                                :label="item.text"
                                             ></v-combobox>
                                          </v-flex>
                                       </v-layout>
                                    </v-container>
                                 </v-card-text>
                                 <v-card-actions class="headline elevation-24">
                                    <v-btn
                                       color="success lighten-1"
                                       v-if="!state"
                                       block
                                       round
                                       @click="setAccessInOneArray"
                                    >Autorizar</v-btn>
                                 </v-card-actions>
                              </v-card>
                           </v-dialog>
                           <!-- Dialog de acessos -->
                        </v-layout>
                     </v-container>
                  </v-card-text>
                  <v-card-actions class="headline elevation-24">
                     <v-btn
                        color="success lighten-1"
                        block
                        round
                        @click="sendDataToFatherComponent"
                     >Finalizar</v-btn>
                  </v-card-actions>
               </v-card>
            </v-dialog>
         </v-layout>
      </v-flex>
   </v-layout>
</template>

<script>
import AccessItems from './../../data/Access/access'
import CompanyService from './../../service/CompanyService'
export default {
   async beforeMount() {
      await this.fillCompaniesTable()
      this.loadOptionsOfAccess()
      this.initialize()
   },
   data() {
      return {
         access: {
            company: {}, //id
            entities: [],
         },
         accesses: [],
         actions: [
            {
               title: 'Criar',
               value: 'POST',
            },
            {
               title: 'Visualizar',
               value: 'GET',
            },

            {
               title: 'Editar',
               value: 'PUT',
            },
            {
               title: 'Excluir',
               value: 'DELETE',
            },
         ],
         close: false,
         company: {},
         companies: [],
         dialogComponent: false,
         edit: false, //qundo estou editando os acessos
         editIndex: -1, //posiçao de edição
         editUser: false, //quando estou editando o usuário
         entitiesList: [],
         list: false,
         selected: [],
         state: false,
      }
   },
   methods: {
      init() {
         this.selected = []
         this.access = {
            company: '', //id
            entities: [],
         }
         this.edit = false
         this.editIndex = -1
      },
      //TELA
      open() {
         this.init()
         this.company = {}
         this.dialogComponent = true
      },
      closeDialogAccess() {
         this.init()
         this.list = false
      },
      closeDialog() {
         this.initialize()
         this.state = false
         this.dialogComponent = false
      },
      /* Quando ele é carregado */
      editUserAccess(userAccess) {
         this.accesses = JSON.parse(JSON.stringify(userAccess)) //gera copia do array
         this.editUser = true
      },
      readMode() {
         this.state = true
      },
      initialize() {
         this.selected = []
         this.access = {
            company: {}, //id
            entities: [],
         }
         this.edit = false
         this.company = {}
         this.accesses = []
      },

      /* para quando o dialog estiver aberto   */
      showList(elem) {
         this.init()
         this.company = elem

         let loop = true
         for (let index = 0; index < this.accesses.length && loop; index++) {
            if (this.accesses[index].company._id == this.company._id) {
               this.edit = true
               this.editIndex = index
               this.access = this.accesses[index]
               loop = false
            }
         }
         if (this.edit) {
            this.editAccess()
         } else {
            this.init()
            this.list = true
         }
      },
      editAccess() {
         for (let index = 0; index < this.access.entities.length; index++) {
            const element = this.access.entities[index]
            for (let j = 0; j < this.entitiesList.length; j++) {
               if (element.entity == this.entitiesList[j].entity) {
                  this.selected[j] = element.levels
               }
            }
         }
         this.access={
           company:{},
           entities:[]
         }
         this.list = true
      },
      setAccessInOneArray() {
         this.access.company = this.company
         
         for (let index = 0; index < this.selected.length; index++) {
            if (this.selected[index]) {
               this.access.entities.push({
                  entity: this.entitiesList[index].entity,
                  levels: this.selected[index],
               })
            }
         }
         if (this.editIndex != -1) {
            this.accesses[this.editIndex] = this.access
         } else {
            this.accesses.push(this.access)
         }
         this.closeDialogAccess()
      },
      sendDataToFatherComponent() {
        console.log(this.accesses);
         this.$emit('sendData', this.accesses)
      },

      //BUSCAS
      loadOptionsOfAccess() {
         this.entitiesList = AccessItems.getItems()
      },
      async fillCompaniesTable() {
         try {
            this.companies = await CompanyService.getCompaniesForSpecificData()
         } catch (error) {
            console.log(error)
         }
      },
      companyText: item => `${item.socialName} - ${item.fantasyName}`,
   },
}
</script>


<style scoped>
.card-company:hover {
   cursor: pointer;
   background-color: rgba(66, 66, 255, 0.87);
   color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/TableAccess.vue